import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { ElementFormComponent } from "./element-form/element-form.component";
import { ElementFormulaComponent } from "./element-formula/element-formula.component";
import { ElementListComponent } from "./element-list/element-list.component";
import { ElementPriorityFormComponent } from "./element-priority-form/element-priority-form.component";
import { ElementPropertyFormComponent } from "./element-property-form/element-property-form.component";

const components = [ElementFormComponent, ElementListComponent, ElementPriorityFormComponent];
@NgModule({
  declarations: [...components, ElementPropertyFormComponent, ElementFormulaComponent],
  exports: [...components],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, SharedModule, SepidzGridModule, TreeViewModule],
})
export class ElementModule {}
